import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { connect, useDispatch } from "react-redux";
import { MY_PROFILE, SITE_URL } from "../../../actions/types";
import {
  Download_Invoice_PDF,
  invoiceDetail,
} from "../../../actions/transactions";
import Loader from "../loader";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const Invoice = () => {
  const [transactionDetails, setTransactionDetails] = useState("");

  const { id } = useParams();
  const dispatch = useDispatch();
  const fetchInvoiceDetails = async () => {
    dispatch(invoiceDetail(id)).then((res) => {
      if (res.success) {
        //console.log(res.data[0], "MY_RES");
        setTransactionDetails(res?.data);
      }
    });
  };

  useEffect(() => {
    fetchInvoiceDetails();
    fetchInvoiceDetails();
  }, [id]);

  const DownloadPDF = () => {
    const obj = {
      name: transactionDetails[0]?.name,
      email: transactionDetails[0]?.email,
      phone: transactionDetails[0]?.phone,
      invoiceNumber: transactionDetails[0]?.invoice_id,
      date: transactionDetails[0]?.billing_date.split("T")[0],
      items: [
        {
          description: transactionDetails[0]?.subscription_title,
          price: transactionDetails[0]?.value,
          total: transactionDetails[0]?.value,
        },
      ],
      subtotal: transactionDetails[0]?.value,
      discount: "0%",
      total: transactionDetails[0]?.value,
      logoPath: "https://app.raterdate.com/img/group-6.svg", // Adjust path according to where the image is stored
    };

    dispatch(Download_Invoice_PDF(obj));
  };

  return (
    <>
      <>
        <div id="wrapper" style={{ color: "black" }}>
          <Sidebar />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Header />
              <div className="container-fluid">
                <div className="card shadow mb-4">
                  <div className="card-header py-3">
                    <div>
                      <a href="/transactions" className="mb-5">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span className="ms-2">Back</span>
                      </a>
                      <i className="fas fa-arrow" />
                    </div>
                    <h6 className="m-0 mt-3 font-weight-bold text-primary">
                      Invoice Detail
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="content-body"
                        style={{ width: "100%", backgroundColor: "#fff" }}
                      >
                        <div
                          id="invoice-template"
                          className="invoice-template file-export"
                          style={{
                            padding: "0px 30px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <div style={{ minHeight: "620px" }}>
                            <div style={{ minWidth: "600px" }}>
                              <header
                                style={{
                                  borderBottom: "1px solid #4e73df",
                                  paddingBottom: "10px",
                                  overflow: "hidden",
                                }}
                              >
                                <div>
                                  <div style={{ width: "50%", float: "left" }}>
                                    <img
                                      className="student_logo w35"
                                      src={`/img/group-6.svg`}
                                      alt="logo"
                                      onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                                        e.target.src = "img/noImage.png"; // Fallback image if loading fails
                                      }}
                                    />
                                  </div>
                                </div>
                              </header>
                              <main style={{ paddingBottom: "50px" }}>
                                <div
                                  style={{
                                    margin: "20px 0",
                                    minHeight: "100px",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50%",
                                      float: "left",
                                      fontFamily:
                                        "Arial, Helvetica, sans-serif",
                                    }}
                                  >
                                    <div>INVOICE TO:</div>
                                    <h3 className="mb-2" style={{ margin: 0 }}>
                                      {transactionDetails &&
                                        transactionDetails[0]?.name}
                                    </h3>
                                    <div className="mb-2">
                                      <a
                                        href={`mailto:${transactionDetails[0]?.email}`}
                                      >
                                        {transactionDetails[0]?.email}
                                      </a>
                                    </div>
                                    <div>
                                      Phone: {transactionDetails[0]?.phone}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "right",
                                      width: "50%",
                                      float: "right",
                                      fontFamily:
                                        "Arial, Helvetica, sans-serif",
                                    }}
                                  >
                                    <h2
                                      style={{ marginTop: 0, color: "#4e73df" }}
                                    >
                                      INVOICE #
                                      {transactionDetails[0]?.invoice_id}{" "}
                                    </h2>
                                    <div>
                                      {" "}
                                      Date of Invoice:{" "}
                                      {
                                        transactionDetails[0]?.billing_date.split(
                                          "T"
                                        )[0]
                                      }
                                    </div>
                                  </div>
                                </div>
                                <table
                                  border={0}
                                  cellSpacing={0}
                                  cellPadding={0}
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                    marginBottom: "20px",
                                    fontFamily: "Arial, Helvetica, sans-serif",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        colSpan={1}
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight: 400,
                                          fontSize: "16px",
                                          padding: "15px",
                                          background: "#4e73df",
                                          borderBottom: "1px solid #fff",
                                          color: "#fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        #
                                      </th>
                                      <th
                                        colSpan={2}
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight: 400,
                                          fontSize: "16px",
                                          padding: "15px",
                                          background: "#4e73df",
                                          borderBottom: "1px solid #fff",
                                          color: "#fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Item
                                      </th>
                                      <th
                                        colSpan={2}
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight: 400,
                                          fontSize: "16px",
                                          padding: "15px",
                                          background: "#4e73df",
                                          borderBottom: "1px solid #fff",
                                          color: "#fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Price
                                      </th>
                                      <th
                                        colSpan={2}
                                        style={{
                                          whiteSpace: "nowrap",
                                          fontWeight: 400,
                                          fontSize: "16px",
                                          padding: "15px",
                                          background: "#4e73df",
                                          borderBottom: "1px solid #fff",
                                          color: "#fff",
                                          textAlign: "center",
                                        }}
                                      >
                                        Total
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        colSpan={1}
                                        style={{
                                          textAlign: "center",
                                          whiteSpace: "nowrap",
                                          fontSize: "1.6em",
                                          background: "#ddd",
                                          padding: "15px",
                                          fontSize: "1em",
                                          borderBottom: "1px solid #fff",
                                        }}
                                      >
                                        1
                                      </td>
                                      <td
                                        colSpan={2}
                                        style={{
                                          textAlign: "center",
                                          whiteSpace: "nowrap",
                                          background: "#ddd",
                                          borderBottom: "1px solid #fff",
                                          fontSize: "1em",
                                          padding: "15px",
                                        }}
                                      >
                                        <h3
                                          style={{
                                            margin: 0,
                                            fontWeight: 400,
                                            fontSize: "1.2em",
                                          }}
                                        >
                                          {
                                            transactionDetails[0]
                                              ?.subscription_title
                                          }
                                        </h3>
                                      </td>
                                      <td
                                        colSpan={2}
                                        style={{
                                          textAlign: "center",
                                          background: "#ddd",
                                          borderBottom: "1px solid #fff",
                                          fontSize: "1em",
                                          padding: "15px",
                                        }}
                                      >
                                        ${transactionDetails[0]?.value}
                                      </td>
                                      <td
                                        colSpan={2}
                                        style={{
                                          textAlign: "center",
                                          background: "#ddd",
                                          borderBottom: "1px solid #fff",
                                          fontSize: "1em",
                                          padding: "15px",
                                        }}
                                      >
                                        ${transactionDetails[0]?.value}
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td
                                        colSpan={3}
                                        style={{
                                          textAlign: "right",
                                          background: "0 0",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1em",
                                          border: "none",
                                        }}
                                      />
                                      <td
                                        colSpan={2}
                                        style={{
                                          textAlign: "center",
                                          background: "0 0",
                                          borderBottom: "none",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1em",
                                          borderTop: "1px solid #aaa",
                                        }}
                                      >
                                        SUBTOTAL
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          background: "0 0",
                                          borderBottom: "none",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1em",
                                          borderTop: "1px solid #aaa",
                                        }}
                                      >
                                        ${transactionDetails[0]?.value}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        colSpan={3}
                                        style={{
                                          textAlign: "right",
                                          background: "0 0",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1em",
                                          border: "none",
                                        }}
                                      />
                                      <td
                                        colSpan={2}
                                        style={{
                                          textAlign: "center",
                                          background: "0 0",
                                          borderBottom: "none",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1em",
                                          borderTop: "1px solid #aaa",
                                        }}
                                      >
                                        DISCOUNT
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          background: "0 0",
                                          borderBottom: "none",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1em",
                                          borderTop: "1px solid #aaa",
                                        }}
                                      >
                                        0%
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        colSpan={3}
                                        style={{
                                          textAlign: "right",
                                          background: "0 0",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1em",
                                          border: "none",
                                        }}
                                      />
                                      <td
                                        colSpan={2}
                                        style={{
                                          textAlign: "center",
                                          background: "0 0",
                                          borderBottom: "none",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1.5em",
                                          borderTop: "1px solid #aaa",
                                        }}
                                      >
                                        GRAND TOTAL
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          background: "0 0",
                                          borderBottom: "none",
                                          whiteSpace: "nowrap",
                                          padding: "10px 20px",
                                          fontSize: "1.5em",
                                          borderTop: "1px solid #aaa",
                                        }}
                                      >
                                        ${transactionDetails[0]?.value}
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </main>
                              <footer
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  color: "#777",
                                  borderTop: "1px solid #4e73df",
                                  paddingTop: "8px",
                                  fontFamily: "Arial, Helvetica, sans-serif",
                                }}
                              >
                                Invoice was created on a computer and is valid
                                without the signature and seal.
                              </footer>
                            </div>
                          </div>
                        </div>
                        <div style={{ width: "10%", float: "right" }}>
                          <a
                            // href={`${MY_PROFILE}${transactionDetails[0]?.invoice_link}`}
                            onClick={DownloadPDF}
                            download
                            target="blank"
                          >
                            <button class="btn btn-primary">Download</button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Invoice;
